import { render, staticRenderFns } from "./MyFarmes.html?vue&type=template&id=1438cf3e&external"
import script from "./MyFarmes.js?vue&type=script&lang=js&external"
export * from "./MyFarmes.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports